module.exports = __webpack_public_path__ + "static/media/AngelsOfAether_Race_14.b5302b0d.jpg";